import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function GoogleAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuthData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }

    const sessionId = match[1];

    const exchange = async () => {
      try {
        const referralCode = localStorage.getItem('uclean_pending_ref') || undefined;
        localStorage.removeItem('uclean_pending_ref');
        const res = await axios.post(`${API}/api/auth/google-session`, { session_id: sessionId, referral_code: referralCode });
        const { access_token, user } = res.data;

        localStorage.setItem('token', access_token);
        if (setAuthData) {
          setAuthData({ token: access_token, user });
        }

        // Save locale and timezone
        try {
          const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
          const locale = document.cookie.match(/uclean_locale=([^;]+)/)?.[1] || navigator.language || 'pt-BR';
          await axios.patch(`${API}/api/locale/user`, { locale, timezone: tz }, {
            headers: { Authorization: `Bearer ${access_token}` },
          });
        } catch { /* ignore */ }

        // Clean hash
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/feed', { replace: true });
      } catch {
        navigate('/login', { replace: true });
      }
    };

    exchange();
  }, [location.hash, navigate, setAuthData]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(180deg, #0a0a1a 0%, #111133 50%, #0a0a1a 100%)' }}>
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-purple-500 mx-auto mb-4" />
        <p className="text-gray-400 text-sm">Autenticando com Google...</p>
      </div>
    </div>
  );
}
